import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebaseConfig';
import { collection, query, where, getDocs, doc, getDoc, updateDoc, addDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import '../styles/IineNotDisplay.css';
import '../styles/Iine.css';
import { BiSolidLike } from "react-icons/bi";
import MenuBar from '../components/MenuBar';

const IineNotDisplay = () => {
  const [user] = useAuthState(auth);
  const [rejectedUsers, setRejectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRejectedUsers = async () => {
      if (!user) return;

      setLoading(true);
      console.log("Fetching rejected users...");

      try {
        const likesQuery = query(collection(db, "likes"), where("to", "==", user.uid), where("status", "==", "rejected"));
        const likesSnapshot = await getDocs(likesQuery);

        if (likesSnapshot.empty) {
          setRejectedUsers([]);
          return;
        }

        const userIds = likesSnapshot.docs.map(doc => doc.data().from);
        const userDocs = await Promise.all(userIds.map(userId => getDoc(doc(db, "members", userId))));

        const usersData = userDocs
          .filter(userDoc => userDoc.exists())
          .map(userDoc => ({ id: userDoc.id, ...userDoc.data() }));

        setRejectedUsers(usersData);
        console.log("Rejected users loaded:", usersData);
      } catch (error) {
        console.error("Error fetching rejected users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedUsers();
  }, [user]);

  const handleApprove = async (rejectedUser) => {
    if (!user) return;

    console.log("Approving like for:", rejectedUser.id);

    try {
      const likeQuery = query(
        collection(db, "likes"),
        where("from", "==", rejectedUser.id),
        where("to", "==", user.uid),
        where("status", "==", "rejected")
      );
      const likeSnapshot = await getDocs(likeQuery);

      if (likeSnapshot.empty) return;

      const likeDoc = likeSnapshot.docs[0];
      await updateDoc(likeDoc.ref, { status: "approved" });

      await addDoc(collection(db, "chats"), {
        participants: [user.uid, rejectedUser.id],
        createdAt: new Date(),
      });

      console.log("Like approved for:", rejectedUser.id);
      alert("マッチングしました！");
      setRejectedUsers(prevUsers => prevUsers.filter(u => u.id !== rejectedUser.id));
    } catch (error) {
      console.error("Error approving like:", error);
    }
  };

  if (loading) return <div className="loading-message">Loading...</div>;

  return (
    <div className="iine-container">
      <div className="settings-header">
        <p className="iine-skip">いいねをスキップしたユーザー</p>
      </div>
      <div className="likes-list">
        {rejectedUsers.map(rejectedUser => (
          <div key={rejectedUser.id} className="like-card">
            <Link to={`/other_member_profile/${rejectedUser.id}`} className="like-card-link">
              <img 
                src={rejectedUser.photoURL || "/images/default.png"} 
                alt="Profile" 
                className="like-card-image" 
                onError={(e) => e.target.src = "/images/default.png"} 
              />
              <div className="like-card-info">
                <h3>{rejectedUser.name || "Unknown User"}</h3>
                <p>{rejectedUser.location || "--"}</p>
              </div>
            </Link>
            <div className="like-card-buttons">
              <button onClick={() => handleApprove(rejectedUser)} className="like-card-button iine-approve">
                <BiSolidLike />
              </button>
            </div>
          </div>
        ))}
      </div>
      <MenuBar />
    </div>
  );
};

export default IineNotDisplay;
